import React from 'react';
import SocialCommitment from './SocialCommitment';
import CreateImpact from './CreateImpact';

const StoryCard = () => {
	return (
	  <div className="w-full max-w-7xl mx-auto">
		<div className="flex flex-col lg:flex-row">
		  {/* Left side - Image */}
		  <div className="w-full lg:w-1/2 relative flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12 order-2 lg:order-1">
			<div className="relative w-full max-w-lg">
			  {/* Placeholder for the 3D metallic arrow/pointer image */}
			  {/* <div className="w-full h-64 lg:h-80 bg-gradient-to-br from-gray-300 via-gray-200 to-gray-400 rounded-lg shadow-lg flex items-center justify-center relative overflow-hidden"> */}
				{/* Arrow shape placeholder */}
				<div className="relative w-full h-full">
				  <img src="/images/stoy-1.png" alt="Arrow" className="w-full h-48 sm:h-56 md:h-64 lg:h-[320px] object-cover rounded-lg" />
				 
				</div>
				  
			  
			  {/* Top text */}
			 
			</div>
		  </div>
   
		  {/* Right side - Content */}
		  <div className="w-full lg:w-1/2 p-4 sm:p-6 md:p-8 lg:p-12 flex flex-col justify-center text-center lg:text-left order-1 lg:order-2">
			<div className="space-y-4 sm:space-y-5 md:space-y-6">
			  <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl font-light font-source text-[#113861] leading-tight">
			  <span className="text-[#113861] italic font-bold">Our</span> <span className="text-[#113861] font-sans italic">story</span>
			  </h2>
			  
			  <div className="space-y-3 sm:space-y-4 text-gray-600 leading-relaxed">
				<p className="text-sm sm:text-base md:text-lg lg:text-base xl:text-lg font-sans font-regular text-[#2b2b2b] max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
				  Born from behavioural scientists, educators and designers working side by side, we've spent over a decade studying human behaviour and real-world action. Our approach cuts to the system, uncovering the precise and breakthrough thinking that pushes yourself and find making the path to meaningful change.
				</p>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	);
  };

// Mission Section Component
const MissionSection = () => {
  return (
    <div className="w-full max-w-7xl mx-auto mb-8 sm:mb-12 md:mb-16">
      <div className="flex flex-col lg:flex-row items-center">
        {/* Left side - Text */}
        <div className="lg:w-1/2 p-4 sm:p-6 md:p-8 lg:p-12 text-center lg:text-left">
          <div className="space-y-4 sm:space-y-5 md:space-y-6">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl font-light font-source text-[#113861] leading-tight">
              	<span className="text-[#113861] italic font-bold">Our</span> <span className="text-[#113861] font-sans italic">mission</span>
            </h2>
            
            <div className="space-y-3 sm:space-y-4 text-gray-600 leading-relaxed">
              <p className="text-sm sm:text-base md:text-lg lg:text-base xl:text-lg font-sans font-regular text-[#2b2b2b] max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
                We deliver science-backed assessments that spark self-awareness, guide clear decision-making and fuel growth in both individuals and institutions.
              </p>
            </div>
          </div>
        </div>

        {/* Right side - Arrow pointing right */}
		<div className="lg:w-1/2 relative flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12">
			<div className="relative w-full max-w-lg">
			  {/* Placeholder for the 3D metallic arrow/pointer image */}
			  {/* <div className="w-full h-64 lg:h-80 bg-gradient-to-br from-gray-300 via-gray-200 to-gray-400 rounded-lg shadow-lg flex items-center justify-center relative overflow-hidden"> */}
				{/* Arrow shape placeholder */}
				<div className="relative w-full h-full">
				  <img src="/images/stoy-2.png" alt="Arrow" className="w-full h-48 sm:h-56 md:h-64 lg:h-[320px] object-cover rounded-lg" />
				 
				</div>
				  
			  
			  {/* Top text */}
			 
			</div>
		</div>
      </div>
    </div>
  );
};

// Vision Section Component
const VisionSection = () => {
  return (
    <div className="w-full max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row items-center">
        {/* Left side - Arrow pointing left (flipped) */}
		<div className="w-full lg:w-1/2 relative flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12 order-2 lg:order-1">
			<div className="relative w-full max-w-lg">
			  {/* Placeholder for the 3D metallic arrow/pointer image */}
			  {/* <div className="w-full h-64 lg:h-80 bg-gradient-to-br from-gray-300 via-gray-200 to-gray-400 rounded-lg shadow-lg flex items-center justify-center relative overflow-hidden"> */}
				{/* Arrow shape placeholder */}
				<div className="relative w-full h-full">
				  <img src="/images/story.png" alt="Arrow" className="w-full h-48 sm:h-56 md:h-64 lg:h-[320px] object-cover rounded-lg" />
				 
				</div>
				  
			  
			  {/* Top text */}
			 
			</div>
		</div>

        {/* Right side - Text */}
        <div className="w-full lg:w-1/2 p-4 sm:p-6 md:p-8 lg:p-12 text-center lg:text-left order-1 lg:order-2">
          <div className="space-y-4 sm:space-y-5 md:space-y-6">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl font-light font-source text-[#113861] leading-tight">
			<span className="text-[#113861] italic font-bold">Our</span> <span className="text-[#113861] font-sans italic">vision</span>
            </h2>
            
            <div className="space-y-3 sm:space-y-4 text-gray-600 leading-relaxed">
              <p className="text-sm sm:text-base md:text-lg lg:text-base xl:text-lg font-sans font-regular text-[#2b2b2b] max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
                By weaving together research and cultural intelligence, we help shape future-ready graduates and thoughtful leaders. Our tools empower confident academic and life choices and give educational institutions evidence-based strategies that scale.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Component
const StoryMissionVision = () => {
  return (
    <div className="min-h-[fit-content] bg-gray-50">
      <main className="flex-1 py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-8">
          <div className="space-y-8 sm:space-y-10 md:space-y-12 lg:space-y-16">
            <StoryCard />
            <MissionSection />
            <VisionSection />
          </div>
        </div>
      </main>
      
      {/* Social Commitment Section */}
      <SocialCommitment />
      
      {/* Create Impact Section */}
      <CreateImpact />
    </div>
  );
};

export default StoryMissionVision;